import { render, staticRenderFns } from "./MyArchive.vue?vue&type=template&id=0063e1f4&scoped=true"
import script from "./MyArchive.vue?vue&type=script&lang=js"
export * from "./MyArchive.vue?vue&type=script&lang=js"
import style0 from "./MyArchive.vue?vue&type=style&index=0&id=0063e1f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0063e1f4",
  null
  
)

export default component.exports